// src/components/ImageCropper.jsx
import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/cropImage';

const ImageCropper = ({ imageSrc, aspect, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Called continuously as the user adjusts the crop area
  const onCropCompleteInternal = useCallback((croppedArea, croppedAreaPixels) => {
    // Debug: log the cropped area pixels to verify
    console.log('Cropped Area Pixels:', croppedAreaPixels);
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Called when the user clicks the Crop button
  const handleCrop = async () => {
    if (!croppedAreaPixels) {
      alert('Cropping not ready yet.');
      return;
    }
    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropComplete(croppedImageBlob);
    } catch (error) {
      console.error('Error cropping image:', error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-full max-w-4xl h-96">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onCropComplete={onCropCompleteInternal}
          onZoomChange={setZoom}
        />
      </div>
      <div className="mt-4 flex space-x-4">
        <button 
          onClick={handleCrop} 
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark focus:outline-none"
        >
          Crop
        </button>
        <button 
          onClick={onCancel} 
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 focus:outline-none"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ImageCropper;
